import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/PreAdvise/TrackMultipleContainer.css';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import searchimg from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
class TrackMultipleContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            truckdata: [
                { id: 1, bookingNo: "12345" },
                { id: 2, bookingNo: "67890" },
                { id: 3, bookingNo: "24680" }],
            search: "",
            searchlength: 0,
            truckdatatemporary: []
        }
        this.handlechangeSearchBookingNo = this.handlechangeSearchBookingNo.bind(this);
    }
    handleContainer = event => {
        this.state.truckdatatemporary.find((truckdataStorage) => {
            if (truckdataStorage.id === event + 1) {
                localStorage.setItem("truckBookingNoLS", truckdataStorage.bookingNo);
                this.props.history.push('/PreadviseExcelDetails', truckdataStorage.bookingNo)
            }
        })
    }
    handlechangeSearchBookingNo = (e) => {
        this.setState({
            search: e.target.value,
            searchlength: e?.target?.value?.length
        });
    };
    searchBooking = () => {
        if (this.state.searchlength > 0) {
            const truckdatafilter = this.state.truckdata?.filter(i => i?.bookingNo == this.state.search)
            this.setState({ truckdatatemporary: truckdatafilter });
            console.log("inside search function", this.state.truckdatatemporary);
        }
    }
    render() {
        if (this.state.searchlength == 0) {
            this.state.truckdatatemporary = this.state.truckdata;
            console.log("inside render search", this.state.truckdatatemporary);
        }
        return (
            <div class="csoutercolormul">
                <MetaDecorator title={TitleDescription.trackMultipleContainerPageTitle} description={TitleDescription.trackMultipleContainerPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullmul">
                    <div id="csnobox1mul">
                        <nav class="ccnononavbarmul">
                            <div className="ccnonavbarnamemul">
                                <small id="nonavcmul"> Track History for Multiple Containers</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="notificationmaincardmul">
                            <div class="concsdivlow1mul">
                                <div class="csdivlow2mul">
                                    <input
                                        className="appointmentSearchmul"
                                        placeholder="Search by Booking No."
                                        autoComplete="off"
                                        id="secrchInput1mul"
                                        onChange={this.handlechangeSearchBookingNo}
                                        value={this.state.search}
                                    ></input>
                                    <img onClick={this.searchBooking} id="search_imgmul" src={searchimg} width="16" height="16" />
                                </div>
                            </div>
                            <div class="consdiv1mul">
                                {(this.state.truckdatatemporary?.map((truckdatatemporary, index) => {
                                    return (
                                        <div class="outdivinside" onClick={() => this.handleContainer(index)}>
                                            <div class="seconddivv">
                                                <div class="leftout1divv">
                                                    <div class="incardleftdiv">
                                                        <small id="bookking">Booking No. :</small>
                                                        <small id="bookkingvalue">{truckdatatemporary?.bookingNo}</small>
                                                    </div>
                                                </div>
                                                <div class="rightout1div">
                                                    <div class="imgdivout1">
                                                        <img src={rightarrow} id="rightarrowimgmultiple" height="16" width="16" class="" alt="" loading="lazy" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>);
                                }))}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="notifooter01">
                    <Footer />
                </div>
                <div class="notifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default TrackMultipleContainer;
